/**
 * Résolveur statique d'icônes Lucide React.
 *
 * Pourquoi ce fichier : utiliser `LucideIcons[name]` en accès dynamique
 * crée une "MemberExpression" que le plugin Babel visual-edits d'Emergent
 * n'arrive pas à analyser (Maximum call stack exceeded sur les grands tableaux).
 *
 * Solution : objet littéral statique → résolution O(1) au runtime, AST clean.
 */
import {
  Activity, AlertTriangle, ArrowRightLeft, Battery, BatteryCharging,
  Building, Camera, Circle, Cloud, Cpu, Disc, Download, Droplets,
  Gamepad2, HardDrive, Image, Keyboard, Laptop, Monitor, Plug,
  RefreshCw, ScanFace, Send, Server, Share, Shield, ShieldCheck,
  ShoppingBag, Smartphone, Sparkles, Store, Tablet, Thermometer,
  Watch, Wifi, Wine, Wrench,
} from "lucide-react";

const ICONS = {
  Activity,
  AlertTriangle,
  ArrowRightLeft,
  Battery,
  BatteryCharging,
  Building,
  Camera,
  Circle,
  Cloud,
  Cpu,
  Disc,
  Download,
  Droplets,
  Gamepad2,
  HardDrive,
  Image,
  Keyboard,
  Laptop,
  Monitor,
  Plug,
  RefreshCw,
  ScanFace,
  Send,
  Server,
  Share,
  Shield,
  ShieldCheck,
  ShoppingBag,
  Smartphone,
  Sparkles,
  Store,
  Tablet,
  Thermometer,
  Watch,
  Wifi,
  Wine,
};

export function getIcon(name) {
  return ICONS[name] || Wrench;
}
